import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Multiple attempts to ensure scroll happens
    // Immediately
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Using window.scrollTo
    window.scrollTo(0, 0);
    
    // With requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
    
    // Backup with setTimeout
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 10);
    
    return () => clearTimeout(timer);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;

